<lang-change></lang-change>
<div class="container login-container">
    <div class="card card-container"> 
        <p id="profile-name" class="profile-name-card" i18n>Reset Password</p>
  <form name="form" (ngSubmit)="f.form.valid && forgetPass()" #f="ngForm" novalidate>
      <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !email.valid }">
          <label for="email"  i18n>Email</label>
          <input type="text" class="form-control" name="email" [(ngModel)]="email_input" #email="ngModel" required />
          <div *ngIf="f.submitted && !email.valid" class="help-block" i18n>Email is required</div>
      </div>
      <div class="form-group">
          <button [disabled]="loading" class="btn btn-primary btn-radius btn-block" i18n>Reset</button>
          <img *ngIf="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
          <a [routerLink]="['/login']" class="btn btn-default btn-radius btn-block" i18n>Login</a>
      </div>
      <div *ngIf="email_sent" class="form-group">
        <p i18n>A link to reset your password was sent.</p>
    </div>
  </form>
</div><!-- /card-container -->
</div><!-- /container -->





// WEBPACK FOOTER //
// ./src/app/forgot-password/forgot-password.component.html